import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setIsVisible(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookie_consent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-gray-200 shadow-2xl p-4 md:p-6 animate-slide-up">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="font-semibold text-gray-900 mb-2">🍪 Çerezleri Kullanıyoruz</h3>
            <p className="text-sm text-gray-600">
              Web sitemizde deneyiminizi geliştirmek için çerezler kullanıyoruz. 
              Sitemizi kullanmaya devam ederek çerez kullanımını kabul etmiş olursunuz.
            </p>
          </div>
          <div className="flex items-center gap-3">
            <Button
              onClick={rejectCookies}
              variant="outline"
              size="sm"
              className="whitespace-nowrap"
            >
              Reddet
            </Button>
            <Button
              onClick={acceptCookies}
              className="bg-[#dc2626] hover:bg-[#b91c1c] whitespace-nowrap"
              size="sm"
            >
              Kabul Et
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
